
import { Contract } from '@ethersproject/contracts'

// hooks
import useYam from '../bakery/useYam'
import { userNFTContract } from '../../userType/userNFTContract'

export function useBakeryArtworkNFTContract(type: string): Contract | null  {
  const sushi = useYam()
  let contract = userNFTContract(sushi, type)
  return contract
}
